import Marquee from "react-fast-marquee";

const WORDS = [
  "Integrity",
  "Hospitality",
  "Respect",
  "Five-Star Recognition",
  "Higher Rankings",
  "Sustainable Growth",
];

export default function EditorialMarquee() {
  return (
    <section
      data-testid="editorial-marquee"
      className="border-y border-border bg-[var(--blush)] py-8"
    >
      <Marquee speed={38} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="serif italic text-2xl sm:text-4xl text-foreground/85 px-12">
              {w}
            </span>
            <span className="text-[var(--gold)] text-2xl sm:text-3xl">&#10022;</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
